export default function validateExternalId({ externalId }: { externalId: string }) {
  const matches = externalId.match(/[^a-z\d-]/i);

  if (matches) {
    return [{ field: "externalId", error: "invalid" }];
  }

  return [];
}
